// --- Custom Element Definition: variant-selects ---
if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(({ dataset }) => dataset.optionValueId);
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          // Bestehende Logik: Swatch-Werte aktualisieren
          this.updateSelectedSwatchValue(event);

          // Bestehende Pub/Sub-Meldung (sofern benötigt)
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });

          // === NEUER CODE: Ermittlung der aktuellen Variantendaten und Dispatch des Custom Events ===
          let variantTitle = "";
          let variantPrice = "";

          // Prüfen, ob ein <select> Element verwendet wird
          const selectEl = this.querySelector('select');
          if (selectEl && selectEl.selectedOptions.length) {
            variantTitle = selectEl.selectedOptions[0].textContent.trim();
            variantPrice = selectEl.selectedOptions[0].dataset.price;
          } else {
            // Falls Radiobuttons verwendet werden
            const radioEl = this.querySelector('input[type="radio"]:checked');
            if (radioEl) {
              variantTitle = radioEl.value.trim();
              variantPrice = radioEl.dataset.price;
            }
          }

          // Fallback: Falls kein Preis gefunden wurde – hier für 10ml und 50ml
          if (!variantPrice) {
            if (variantTitle.toLowerCase().includes("10")) {
              variantPrice = "1999"; // 19,99 € in Cent
            } else if (variantTitle.toLowerCase().includes("30")) {
              variantPrice = "3999"; // 49,99 € in Cent
            } else if (variantTitle.toLowerCase().includes("50")) {
              variantPrice = "4999"; // 49,99 € in Cent
            } else if (variantTitle.toLowerCase().includes("100")) {
              variantPrice = "8999"; // 89,99 € in Cent
            }
          }

          const newVariant = {
            title: variantTitle,
            price: variantPrice
          };

          console.log("Dispatching variant:change with newVariant:", newVariant);
          this.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variant: newVariant },
            bubbles: true
          }));
          // === ENDE NEUER CODE ===
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest('.product-form__input').querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}